import React, { useState } from 'react';
import { Box, InputLabel, MenuItem, FormControl, Select } from '@mui/material';
import CodeRenderer from './CodeRenderer';

export const Test = () => {
    const [selected, setSelected] = useState('BoundInteger');

    const handleChange = (event) => {
        setSelected(event.target.value);
    };

    return (
        <Box>
            <Box sx={{ maxWidth: 300, marginBottom: 4 }}>
                <FormControl fullWidth>
                    <InputLabel id="renderer-label">Input Renderer</InputLabel>
                    <Select labelId="renderer-label" value={selected} label="Renderer" onChange={handleChange}>
                        <MenuItem value="BoundInteger">Bound Integer (0-50)</MenuItem>
                        <MenuItem value="UnboundInteger">Unbound Integer</MenuItem>
                        <MenuItem value="MixedInteger">Mixed Integer</MenuItem>
                        <MenuItem value="MixedNumberSideBySide">Mixed Number Side By Side</MenuItem>
                        <MenuItem value="SelectDropdown">Select (dropdown) [Small]</MenuItem>
                        <MenuItem value="Tabs">Tabs [Medium]</MenuItem>
                        <MenuItem value="TabsAllValues">Tabs (combined values) [Large]</MenuItem>
                    </Select>
                </FormControl>
            </Box>

            <CodeRenderer templateName={selected} />
        </Box>
    );
};

export default Test;
